import { faBuilding } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Placeholder } from 'react-bootstrap-5';

type Props = {
  showHeader: boolean;
}

export default function PropertyLoading({ showHeader}: Props) {
  return (
    <div style={{ minHeight: '500px' }}>
      {showHeader && (
        <div className="px-3 py-4 border-bottom">
          <Placeholder animation="wave">
            <div>
              <Placeholder as="h3" lg={4} xs={6} />
            </div>
            <Placeholder as="h6" lg={2} xs={5} />
          </Placeholder>
        </div>
      )}
      <div className="px-3 py-5">
        <div className="text-center">
          <FontAwesomeIcon
            beat
            className="text-primary text-opacity-75"
            icon={faBuilding}
            size="4x"
            style={{
              '--fa-beat-scale': 1.1,
              '--fa-animation-duration': '1.5s',
            } as React.CSSProperties}
          />
        </div>
      </div>
    </div>
  );
}
